import { useState, useEffect, useRef } from "react";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import VideoTimedQuizModal from "../components/VideoTimedQuizModal";

export default function Status({
  videoId,
  history_id,
  videoRef,
  isAPIReady,
  setVideoRef,
}) {
  const [status, setStatus] = useState("NA");
  const [player, setPlayer] = useState(null);
  const [counter, setCounter] = useState(0);
  const [counterRunning, setCounterRunning] = useState(false);
  const [submitDecreaseWatch, setSubmitDecreaseWatch] = useState({
    flag: "",
    dependency: false,
    data: {},
  });
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [unlockedUntil, setUnlockedUntil] = useState(null);
  const [checkpoints, setCheckpoints] = useState([]);
  const lockingRef = useRef(false);

  const [decreaseWatchSuccess, decreaseWatchErrors, decreaseloading] = useAxios(
    process.env.REACT_APP_STUDENT_DECREASE_WATCHE_IN_COURSE_API,
    "POST",
    submitDecreaseWatch.flag,
    submitDecreaseWatch.dependency,
    submitDecreaseWatch.data
  );

  const [timedSuccess] = useAxios(
    videoId
      ? `${process.env.REACT_APP_STUDENT_VIDEO_TIMED_QUESTIONS_API}${videoId}/timed-questions`
      : "",
    "GET",
    videoId ? "GET" : "",
    videoId
  );

  useEffect(() => {
    if (timedSuccess?.enable_timed_questions) {
      setCheckpoints(timedSuccess.data || []);
      setUnlockedUntil(
        timedSuccess.unlocked_until_sec === null ||
          timedSuccess.unlocked_until_sec === undefined
          ? null
          : Number(timedSuccess.unlocked_until_sec)
      );
    } else {
      setCheckpoints([]);
      setUnlockedUntil(null);
    }
  }, [timedSuccess]);

  useEffect(() => {
    let interval;
    if (!videoRef) {
      setPlayer(null);
      return;
    }
    const player = new window.VdoPlayer(videoRef);
    window.player = player;
    setPlayer(player);
    if (player && player.video) {
      player.video.addEventListener("play", () => {
        if (!counterRunning) {
          interval = setInterval(() => {
            setCounter((prevCount) => prevCount + 1);
          }, 1000);
          setCounterRunning(true);
        }
      });

      player.video.addEventListener("pause", () => {
        clearInterval(interval);
      });

      const onTimeUpdate = () => {
        if (!timedSuccess?.enable_timed_questions) return;
        const t = player.video.currentTime || 0;
        const unanswered = checkpoints.filter((q) => !q.is_answered);
        const next = unanswered.find((q) => t >= q.timestamp_sec - 0.25);
        if (next && !lockingRef.current && !activeQuestion) {
          lockingRef.current = true;
          player.video.pause();
          setActiveQuestion(next);
        }
        if (
          unlockedUntil !== null &&
          unlockedUntil !== undefined &&
          t > unlockedUntil + 0.5
        ) {
          player.video.currentTime = Math.max(unlockedUntil - 0.2, 0);
        }
      };

      const onSeeking = () => {
        if (
          unlockedUntil !== null &&
          unlockedUntil !== undefined &&
          player.video.currentTime > unlockedUntil + 0.35
        ) {
          player.video.currentTime = Math.max(unlockedUntil - 0.2, 0);
        }
      };

      player.video.addEventListener("timeupdate", onTimeUpdate);
      player.video.addEventListener("seeking", onSeeking);

      return () => {
        clearInterval(interval);
        player.video.removeEventListener("timeupdate", onTimeUpdate);
        player.video.removeEventListener("seeking", onSeeking);
      };
    }

    window.player = player;

    return () => {
      clearInterval(interval);
    };
  }, [isAPIReady, videoRef, timedSuccess, unlockedUntil, activeQuestion, checkpoints]);

  useEffect(() => {
    setCounter(0);
    setVideoRef(null);
    setActiveQuestion(null);
    lockingRef.current = false;
  }, [videoRef]);

  useEffect(() => {
    if (counter === 600) {
      setSubmitDecreaseWatch({
        flag: "deleteQuestion",
        dependency: !submitDecreaseWatch.dependency,
        data: { id: videoId, history_id: history_id },
      });
    }
  }, [counter, videoId]);

  const handleCorrect = (nextUnlock) => {
    if (activeQuestion) {
      setCheckpoints((prev) =>
        prev.map((q) =>
          q.id === activeQuestion.id ? { ...q, is_answered: 1 } : q
        )
      );
    }
    setActiveQuestion(null);
    lockingRef.current = false;
    setUnlockedUntil(
      nextUnlock === null || nextUnlock === undefined
        ? null
        : Number(nextUnlock)
    );
    if (player?.video) {
      try {
        player.video.play();
      } catch (e) {}
    }
  };

  return (
    <VideoTimedQuizModal
      open={!!activeQuestion}
      question={activeQuestion}
      onCorrect={handleCorrect}
    />
  );
}
